import { toPng } from "html-to-image";
import type { RawGraph } from "./types";

function download(filename: string, url: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
}

export function exportGraphJson(graph: RawGraph, rootAddress: string) {
  const blob = new Blob([JSON.stringify(graph, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  download(`investigation-${rootAddress.slice(0, 10)}.json`, url);
  URL.revokeObjectURL(url);
}

export async function exportGraphPng(element: HTMLElement, rootAddress: string) {
  const dataUrl = await toPng(element, { backgroundColor: "#0D1117" });
  download(`investigation-${rootAddress.slice(0, 10)}.png`, dataUrl);
}
